import {useEffect, useRef, useState} from "react";

function useScrollTrigger(resetKey = null, threshold = 0) {
    const [triggered, setTriggered] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        setTriggered(false);

        const el = ref.current;
        if (!el) {
            return;
        }

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setTriggered(true);
                observer.disconnect();
            }
        }, { threshold });

        observer.observe(el);

        return () => observer.disconnect();
    }, [resetKey]);

    return [ref, triggered];
}

export default useScrollTrigger;
